import { FieldRenderer } from "@/components/tuw/post/FieldRenderer"
import { visibleFieldsOf } from "@/lib/post/fieldValidation"
import { fieldIssue } from "@/lib/openHouse/bookWritingSteps"
import { BundleChoice, IncludedLine } from "./BundleChoice"
import { ManuscriptUpload } from "./ManuscriptUpload"
import { OpenLevelsChoice } from "./OpenLevelsChoice"
import { OutlineChoice } from "./OutlineChoice"

// One Open House step's fields. Today's field types render through today's
// FieldRenderer; the new flow's own controls (outline, open to every level,
// editing's manuscript) render their own composites. Each field is wrapped so a Continue on an
// invalid step, or a submit issue sent back here, can scroll to it. A bundle
// adds its bundle choice and the lines for what its package already includes.
//
// Props: step, values (posting answers + short_description), ctx, oh (Open
// House answers), showErr, serverErrors ({ key: message }), setField(key, v),
// fieldNodes (Map ref), outline ({ upload, onSource, onFile, onRetry, onRemove }),
// manuscript ({ upload, onFile, onRetry, onRemove }).
export function StepFields({ step, values, ctx, oh, showErr, serverErrors = {}, setField, fieldNodes, outline, manuscript }) {
  return visibleFieldsOf(step, values, ctx).map((f, i) => {
    const key = f.key || f.type
    const error = serverErrors[key] || (showErr ? fieldIssue(f, values, ctx, oh) : null)

    let control
    if (f.type === "outline") {
      control = (
        <OutlineChoice
          values={values} ctx={ctx} oh={oh} error={error} setField={setField} paidOption={f.paidOption?.(values, ctx)} {...outline}
        />
      )
    } else if (f.type === "openLevels") {
      control = <OpenLevelsChoice values={values} ctx={ctx} price={f.price} setField={setField} />
    } else if (f.type === "bundle") {
      control = <BundleChoice bundles={ctx.bundles} value={values[f.key]} error={error} onChoose={(v) => setField(f.key, v)} />
    } else if (f.type === "included") {
      control = <IncludedLine text={f.text} />
    } else if (f.type === "manuscript") {
      control = <ManuscriptUpload field={f} value={values[f.key]} error={error} {...manuscript} />
    } else {
      control = <FieldRenderer field={f} values={values} setField={setField} error={error} ctx={ctx} />
    }

    return (
      <div
        key={`${key}-${i}`}
        ref={(node) => {
          if (node) fieldNodes.current.set(key, node)
          else fieldNodes.current.delete(key)
        }}
        data-post-field={key}
        data-validation-error={error ? "true" : undefined}
        className="scroll-mt-6"
      >
        {control}
      </div>
    )
  })
}
